import i18nInstance from 'i18n/i18nInstance'
import { COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE } from '@mc/checkout'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetSessionsSectionProps = {
  isEntryPaintedDoorVariant?: boolean
}

export const getSessionsSection: (
  props: GetSessionsSectionProps,
) => Section = ({ isEntryPaintedDoorVariant }) => ({
  title: t('faq.sessions.title'),
  questions: [
    {
      title: t('faq.sessions.question1'),
      uuid: 'faq.sessions.question1.string',
      answer: (
        <Trans i18nKey='faq.sessions.answer1' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.sessions.question2'),
      uuid: 'faq.sessions.question2.string',
      answer: (
        <Trans
          i18nKey={
            isEntryPaintedDoorVariant
              ? `${COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}:faq.sessions.answer2.string`
              : 'faq.sessions.answer2'
          }
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.sessions.question3'),
      uuid: 'faq.sessions.question3.string',
      answer: (
        <Trans i18nKey='faq.sessions.answer3' t={t}>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
  ],
})
